module.exports = __webpack_public_path__ + "img/img_company_address.6ee3c676.png";